import { FilterOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import styled from 'styled-components'

import { color } from '../../definition'

const FilterBtn = (props) => {
  const onClick = () => {
    let { name, onClick } = props
    if (onClick) onClick(name)
  }

  const {
    className,
    disabled,
    loading,
  } = props

  const css = {
    width: '100%',
  }

  let click
  if (!loading && !disabled) {
    click = onClick
  }
  return (
    <PageView className={className}>
      <Button
        disabled={disabled}
        style={css}
        loading={loading}
        onClick={click}>
        <Icon>
          <FilterOutlined />
        </Icon>
        ตัวกรอง
      </Button>
    </PageView>
  )
}

const PageView = styled.div`
  button {
    border-radius: 4px;
    border: 1px solid ${color.border};
    color: black;
    background-color: white;
  }

  button:hover {
    border: 1px solid black;
    color: black;
    background-color: white;
  }
`

const Icon = styled.span`
  margin-right: 4px;
`

export default FilterBtn
